export default "__VITE_ASSET__xdGB5URd__"